import { validateQueryParameters } from '@/helpers/verifyQueryParameters';
import { createAxiosInstance } from '@/plugins/axios.plugin';
import axios from 'axios';

export default class Dashboards {
  static SERVICE_NAME = 'dashboards';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.DASHBOARDS_API,
      useAccessToken : true,
      customHeaders  : {
        'x-api-key'    : process.env.X_API_KEY_DASHBOARDS,
        'Accept'       : 'application/json',
        'Content-Type' : 'application/json'
      }
    });
  }

  getActivitiesCorrectionQueue(params) {
    const query = validateQueryParameters({
      ids              : params.ids.join(),
      academicMainType : params.academicMainType,
      periods          : params.periods,
      startDate        : params.startDate,
      endDate          : params.endDate,
      perPage          : params.perPage,
      page             : params.page,
      categories       : params.categoryIds
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/operations-center/activities?${query}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getActivitiesCorrectionQueueByAcademicMainId(params) {
    const query = validateQueryParameters({
      perPage       : params.perPage,
      page          : params.page,
      enrollmentIds : params.enrollmentIds
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/operations-center/activities/${params.academicMainId}?${query}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getForums(params) {
    const query = validateQueryParameters({
      perPage         : params.perPage || 10,
      page            : params.page,
      academicMainIds : params.selectedCourseIds.join(),
      periods         : params.periodId,
      startDate       : params.startDate,
      endDate         : params.endDate,
      categories      : params.categoryIds,
      enrollmentIds   : params.enrollmentIds
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/operations-center/forums?${query}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getCourses(params) {
    const query = validateQueryParameters({
      search     : params.search,
      perPage    : params.limit || 10,
      page       : params.page + 1,
      periods    : params.periods,
      startDate  : params.startDate,
      endDate    : params.endDate,
      categories : params.categories
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/operations-center/filter/course?${query}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getProgressChartData(params) {
    const query = validateQueryParameters({
      perPage         : params.perPage || 10,
      page            : params.page,
      periods         : params.periods,
      startDate       : params.startDate,
      endDate         : params.endDate,
      categories      : params.categories,
      academicMainIds : params.academicMainIds?.join() || null
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/student-progress?${query}`, { cancelToken: params.cancelToken })
      .then(response => response.data)
      .catch(error => {
        if (axios.isCancel(error)) {
          return { isCanceled: true };
        }
        return Promise.reject(error.response.data.error);
      });
  }

  getProgressChartStudentsData(params) {
    const query = validateQueryParameters({
      perPage          : params.perPage || 10,
      page             : params.page,
      studentSituation : params.studentSituation,
      sortBy           : params.sortBy,
      students         : params.students?.join() || null
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/student-progress/${params.academicMainId}?${query}`, { cancelToken: params.cancelToken })
      .then(response => response.data)
      .catch(error => {
        if (axios.isCancel(error)) {
          return { isCanceled: true };
        }
        return Promise.reject(error.response.data.error);
      });
  }

  getStudentsPerformanceData(params) {
    const query = validateQueryParameters({
      perPage          : params.perPage || 10,
      page             : params.page,
      studentSituation : params.studentSituation,
      sortBy           : params.sortBy,
      students         : params.students?.join() || null
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/student-performance/${params.academicMainId}?${query}`, { cancelToken: params.cancelToken })
      .then(response => response.data)
      .catch(error => {
        if (axios.isCancel(error)) {
          return { isCanceled: true };
        }
        return Promise.reject(error.response.data.error);
      });
  }

  getCoursesAndIesChartData(params) {
    const query = validateQueryParameters({
      periods         : params.periods,
      startDate       : params.startDate,
      endDate         : params.endDate,
      categories      : params.categories,
      academicMainIds : params.academicMainIds?.join() || null
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/course-average-progress?${query}`, { cancelToken: params.cancelToken })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }
};
